"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NextPrevButton;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Container = (0, _styledComponents.default)(_Flex.default).attrs({
  paddingY: 0.4,
  alignItems: 'center',
  paddingX: 1
}).withConfig({
  displayName: "NextPrevButton__Container",
  componentId: "cpoqd2-0"
})([""]);
var Button = (0, _styledComponents.default)(_Button.default).attrs({
  size: 'small',
  variant: 'ghost'
}).withConfig({
  displayName: "NextPrevButton__Button",
  componentId: "cpoqd2-1"
})(["line-height:1.4;"]);

function NextPrevButton(_ref) {
  var variant = _ref.variant,
      text = _ref.text,
      ariaLabel = _ref.ariaLabel,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      page = _ref.page,
      pageChangeHandler = _ref.pageChangeHandler;
  return _react.default.createElement(Container, null, _react.default.createElement(Button, {
    text: variant === 'compact' ? undefined : text,
    icon: icon,
    iconPosition: iconPosition,
    disabled: !page,
    onClick: function onClick() {
      return page && pageChangeHandler(page);
    },
    "aria-label": ariaLabel || text
  }));
}